// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3pHB6","messages":"Chat_messages__1kbV7","dateDivider":"Chat_dateDivider__1xXG8"};